module.exports = __webpack_public_path__ + "static/media/brujula-zn.6f9fa44f.svg";